var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPen(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "pen"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Stroke 1 (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.879 1.90879C13.3199 1.4679 14.0336 1.4679 14.4744 1.90879L17.1721 4.60643C17.613 5.04732 17.613 5.76099 17.1721 6.20187L8.17621 15.1978C8.09359 15.2804 7.9864 15.334 7.87074 15.3505L3.75309 15.9387C3.58483 15.9628 3.41507 15.9062 3.29489 15.786C3.1747 15.6658 3.11811 15.496 3.14215 15.3278L3.73039 11.2101C3.74691 11.0945 3.8005 10.9873 3.88312 10.9047L12.879 1.90879ZM13.7108 2.67246C13.6917 2.65335 13.6618 2.65335 13.6427 2.67246L4.77408 11.5411L4.31312 14.7678L7.53981 14.3068L16.4084 5.4382C16.4275 5.41908 16.4275 5.38923 16.4084 5.37011L13.7108 2.67246Z",
    fill: "#9FA6B2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 3 (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.8225 3.2568C16.0333 3.46768 16.0333 3.80959 15.8225 4.02047L8.76363 11.0793C8.55275 11.2902 8.21084 11.2902 7.99996 11.0793C7.78908 10.8684 7.78908 10.5265 7.99996 10.3156L15.0588 3.2568C15.2697 3.04591 15.6116 3.04591 15.8225 3.2568Z",
    fill: "#9FA6B2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 5 (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.88277 10.9043C4.09365 10.6934 4.43556 10.6934 4.64645 10.9043L8.17586 14.4337C8.38674 14.6446 8.38674 14.9865 8.17586 15.1973C7.96498 15.4082 7.62307 15.4082 7.41218 15.1973L3.88277 11.6679C3.67189 11.457 3.67189 11.1151 3.88277 10.9043Z",
    fill: "#9FA6B2"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPen);
export default __webpack_public_path__ + "static/media/pen.3fa26c78a8ae44c3f9ef1ed97f2d67f5.svg";
export { ForwardRef as ReactComponent };